/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import VueCookies from 'vue-cookies'
import errorRouter from '@/router/modules/errorRouter'
import LayoutSidebar from '@/layout/layout-sidebar/layout-sidebar.vue'
import Layoutgx from '@/layout/layout-ticket/layout-ticket.vue'
// 随访中心
import followUpRouter from '@/router/modules/followUpRouter/index';
// 电子合同
import electronicContractRouter from '@/router/modules/electronicContractRouter/index';
import {
  yonghu,
  qianzhang,
  fuwubaogl,
  gouwuche,
  dingyue,
  dingdan,
  qianming,
  yujing,
  huanzhe,
  zhanghu,
  shouquan,
  xitong,
  yingyong
} from '@/utils/images'
import { stubTrue } from 'lodash'

Vue.use(Router)
/**
 * 注释:
 * path:""               页面路径
 *
 * name:""               命名视图的路由别名
 *
 * meta:{
 *  roles:["a","b"]      可访问页面的权限,支持多个页面,不填=任意可访问
 *  title:""             页面的名字
 *  activeMenu: '/article/list'     侧边栏高亮,顶部栏高亮
 * }
 */
const defaultRouter = [
  {
    path: '/',
    // redirect: '/procedurelist/statistics',
    name: 'home',
    redirect: (to) => {
      const userLoginInfo = VueCookies.get('userLoginInfo')
      console.log('路由里面的userLoginInfo', userLoginInfo)
      return userLoginInfo && userLoginInfo.type === 1
        ? '/procedurelist/statistics'
        : '/agent/statistics'
    },
  },
  {
    path: '/gx',
    redirect: '/gx/s1',
  },
  {
    path: '/gx',
    component: Layoutgx,
    children: [
      {
        path: '/gx/s1',
        component: () => import('@/layout/layout-ticket/layout-ticket1.vue'),
        name: 's1',
      },
      {
        path: '/gx/s2',
        component: () => import('@/layout/layout-ticket/layout-ticket2.vue'),
        name: 's2',
      },
      {
        path: '/gx/s3',
        component: () => import('@/layout/layout-ticket/layout-ticket3.vue'),
        name: 's3',
      },
    ],
  },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   menuShow: false,
  //   idthat: '1',
  //   leaf: true, // 只有一个节点
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: zhanghu,
  //   children: [
  //     {
  //       path: '/agent/welcome',
  //       component: () => import('@/views/agent/welcome/hospitalSign.vue'),
  //       name: '首页',
  //       menuShow: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   menuShow: false,
  //   idthat: '1',
  //   leaf: true, // 只有一个节点
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: zhanghu,
  //   children: [
  //     {
  //       path: '/agent/openService',
  //       component: () => import('@/views/agent/openService/hospitalSign.vue'),
  //       name: '开通服务',
  //       menuShow: true,
  //     },
  //   ],
  // },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '1', // 权限号码
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: zhanghu,
    meta: {
      idthat: '1',
    },
    children: [
      {
        path: '/procedurelist/statistics',
        component: () =>
          import('@/views/procedurelist/statistics/statistics.vue'),
        name: '账户概览',
        menuShow: true,
        meta: {
          idthat: '1',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '2',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: yonghu,
    meta: {
      idthat: '2',
    },
    children: [
      {
        path: '/procedurelist/userManager',
        component: () =>
          import('@/views/procedurelist/userManager/userManager.vue'),
        name: '用户管理',
        menuShow: true,
        meta: {
          idthat: '2',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '3',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: qianzhang,
    meta: {
      idthat: '3',
    },
    children: [
      {
        path: '/procedurelist/signaManage',
        component: () =>
          import('@/views/procedurelist/signaManage/signaManage.vue'),
        name: '签章管理',
        menuShow: true,
        meta: {
          idthat: '3',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    name: '服务包管理',
    menuShow: false,
    idthat: '4',
    leaf: false, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: fuwubaogl,
    meta: {
      idthat: '4',
    },
    children: [
      {
        path: '/procedurelist/buyServicePackage',
        component: () =>
          import(
            '@/views/procedurelist/buyServicePackage/buyServicePackage.vue'
          ),
        name: '服务包购买',
        iconCls: 'menu-icon', // 图标样式class
        iconUrl: gouwuche,
        menuShow: '',
        meta: {
          idthat: '4',
        },
      },
      {
        path: '/procedurelist/serPackageManagement',
        component: () =>
          import(
            '@/views/procedurelist/serPackageManagement/serPackageManagement.vue'
          ),
        name: '已订阅服务',
        iconCls: 'menu-icon', // 图标样式class
        iconUrl: dingyue,
        menuShow: true,
        meta: {
          idthat: '4',
        },
      },
      {
        path: '/procedurelist/serverOrderList',
        component: () =>
          import('@/views/procedurelist/serverOrderList/serverOrderList.vue'),
        name: '订单管理',
        iconCls: 'menu-icon', // 图标样式class
        iconUrl: dingdan,
        menuShow: true,
        meta: {
          idthat: '4',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    name: '签名订单查询',
    menuShow: false,
    idthat: '5',
    leaf: false, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: qianming,
    meta: {
      idthat: '5',
    },
    children: [
      {
        path: '/procedurelist/orderManager',
        component: () =>
          import('@/views/procedurelist/orderManager/orderManager.vue'),
        name: '医生签名流水查询',
        menuShow: true,
        iconUrl: qianming,
        meta: {
          idthat: '5',
        },
      },
      {
        path: '/procedurelist/hospitalSign',
        component: () =>
          import('@/views/procedurelist/hospitalSign/hospitalSign.vue'),
        name: '医院签章流水',
        menuShow: true,
        iconUrl: qianming,
        meta: {
          idthat: '5',
        },
      }
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '6',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: yujing,
    meta: {
      idthat: '6',
    },
    children: [
      {
        path: '/procedurelist/monitorSearch',
        component: () =>
          import('@/views/procedurelist/monitorSearch/monitorSearch.vue'),
        name: '系统预警查询',
        menuShow: true,
        meta: {
          idthat: '6',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    name: '患者签名',
    menuShow: false,
    idthat: '7',
    leaf: false, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: huanzhe,
    meta: {
      idthat: '7',
    },
    children: [
      {
        path: '/patient/account',
        component: () =>
          import('@/views/procedurelist/patient/account/account.vue'),
        name: '患者签名账号',
        iconCls: 'menu-icon', // 图标样式class
        iconUrl: zhanghu,
        menuShow: true,
        meta: {
          idthat: '7',
        },
      },
      {
        path: '/patient/sign',
        component: () =>
          import('@/views/procedurelist/patient/patientSign/patientSign.vue'),
        name: '患者签名数据',
        iconCls: 'menu-icon', // 图标样式class
        iconUrl: zhanghu,
        menuShow: true,
        meta: {
          idthat: '7',
        },
      },
    ],
  },
  {
    path: '/',
    name: '基础信息管理',
    component: LayoutSidebar,
    leaf: true, // 只有一个节点
    menuShow: false,
    idthat: '8',
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: shouquan,
    // iconCls: 'iconfont icon-xianchangxinjian1', // 图标样式class
    meta: {
      idthat: '8',
    },
    children: [
      {
        path: '/procedurelist/departmentManage',
        component: () =>
          import('@/views/procedurelist/departmentManage/index.vue'),
        name: '科室管理',
        menuShow: true,
        meta: {
          idthat: '8',
        },
      },
    ],
  },
  {
    path: '/',
    name: '部门签章',
    component: LayoutSidebar,
    leaf: true, // 只有一个节点
    menuShow: false,
    idthat: '11',
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: shouquan,
    meta: {
      idthat: '11',
    },
    children: [
      {
        path: '/procedurelist/departmentSignature',
        component: () =>
          import('@/views/procedurelist/departmentSignature/index.vue'),
        name: '部门签章',
        menuShow: true,
        meta: {
          idthat: '11',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: true, // 只有一个节点
    menuShow: false,
    idthat: '9',
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: xitong,
    // iconCls: 'iconfont icon-xianchangxinjian1', // 图标样式class
    meta: {
      idthat: '9',
    },
    children: [
      {
        path: '/procedurelist/announcement',
        component: () =>
          import('@/views/procedurelist/announcement/announcement.vue'),
        name: '系统公告',
        menuShow: true,
        meta: {
          idthat: '9',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '10',
    iconUrl: xitong,
    leaf: true, // 只有一个节点
    meta: {
      idthat: '10',
    },
    children: [
      {
        path: '/myAccount',
        component: () => import('@/views/myAccount/myAccount.vue'),
        name: '设置',
        menuShow: false,
        meta: {
          idthat: '10',
        },
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '110', // 权限号码
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: yingyong,
    meta: {
      idthat: '110',
    },
    children: [
      {
        path: '/followUp/platformApp',
        component: () =>
          import('@/views/followUp/platformApp.vue'),
        name: '平台应用',
        menuShow: true,
        meta: {
          idthat: '110',
        },
      },
    ],
  },
  // --------------代理商 start-------------------//
  /* {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '000',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: zhanghu,
    children: [
      {
        path: '/agent/welcome',
        component: () => import('@/views/agent/welcome/hospitalSign.vue'),
        name: '首页',
        menuShow: true,
      },
    ],
  }, */
  /* {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '000',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: zhanghu,
    children: [
      {
        path: '/agent/openService',
        component: () => import('@/views/agent/openService/hospitalSign.vue'),
        name: '开通服务',
        menuShow: true,
      },
    ],
  }, */
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '000',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: zhanghu,
    children: [
      {
        path: '/agent/statistics',
        component: () => import('@/views/agent/statistics/statistics.vue'),
        name: '账户概览',
        menuShow: true,
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '001',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: yonghu,
    children: [
      {
        path: '/agent/userManager',
        component: () => import('@/views/agent/userManager/userManager.vue'),
        name: '用户管理',
        menuShow: true,
      },
    ],
  },
  {
    path: '/',
    component: LayoutSidebar,
    menuShow: false,
    idthat: '002',
    leaf: true, // 只有一个节点
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: qianzhang,
    children: [
      {
        path: '/agent/customerManagement',
        component: () =>
          import('@/views/agent/customerManagement/customerManagement.vue'),
        name: '客户管理',
        menuShow: true,
      },
      {
        path: '/agent/customerDetail',
        component: () =>
          import(
            '@/views/agent/customerManagement/trusted/components/editCustomer.vue'
          ),
        name: '客户详情',
        menuShow: false,
      },
    ],
  },
  {
    path: '/agent',
    component: LayoutSidebar,
    leaf: false, // 只有一个节点
    menuShow: false,
    idthat: '003',
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: fuwubaogl,
    name: '服务详情',
    redirect: '/agent/orderManage',
    children: [
      {
        path: '/agent/orderManage',
        component: () =>
          import('@/views/agent/serviceDetails/orderManage/index.vue'),
        name: '订单管理',
        iconUrl: gouwuche,
        menuShow: false,
        idthat: '003001',
      },
      {
        path: '/agent/authorizationRecord',
        component: () =>
          import('@/views/agent/serviceDetails/authorizationRecord/index.vue'),
        name: '授权记录管理',
        iconUrl: dingyue,
        // menuShow: stubTrue,
        menuShow: false,
        idthat: '003002',
      },
      {
        path: '/agent/serviceStatusCallback',
        component: () =>
          import(
            '@/views/agent/serviceDetails/serviceStatusCallback/index.vue'
          ),
        name: '回调服务状态',
        iconUrl: dingdan,
        menuShow: false,
        idthat: '003003',
      },
      {
        path: '/agent/subscriptionService',
        component: () =>
          import('@/views/agent/serviceDetails/subscriptionService/index.vue'),
        name: '订阅服务管理',
        iconUrl: qianming,
        menuShow: false,
        idthat: '003004',
      },
    ],
  },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   leaf: true, // 只有一个节点
  //   menuShow: false,
  //   idthat: '11',
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: dingyue,
  //   children: [
  //     {
  //       path: '/agent/vendorAudit',
  //       component: () => import('@/views/agent/vendorAudit/vendorAudit.vue'),
  //       name: '初审厂商审理',
  //       menuShow: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   leaf: true, // 只有一个节点
  //   menuShow: false,
  //   idthat: '12',
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: dingyue,
  //   children: [
  //     {
  //       path: '/agent/vendorAuditBelive',
  //       component: () =>
  //         import('@/views/agent/vendorAuditBelive/vendorAuditBelive.vue'),
  //       name: '可信厂商审理',
  //       menuShow: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   leaf: true, // 只有一个节点
  //   menuShow: false,
  //   idthat: '13',
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: dingyue,
  //   children: [
  //     {
  //       path: '/agent/vendorServerWarning',
  //       component: () =>
  //         import('@/views/agent/vendorServerWarning/vendorServerWarning.vue'),
  //       name: '厂商服务预警',
  //       menuShow: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   leaf: true, // 只有一个节点
  //   menuShow: false,
  //   idthat: '14',
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: dingyue,
  //   children: [
  //     {
  //       path: '/agent/vendorMoney',
  //       component: () => import('@/views/agent/vendorMoney/vendorMoney.vue'),
  //       name: '厂商费用统计',
  //       menuShow: true,
  //     },
  //   ],
  // },
  // {
  //   path: '/',
  //   component: LayoutSidebar,
  //   leaf: true, // 只有一个节点
  //   menuShow: false,
  //   idthat: '15',
  //   iconCls: 'menu-icon', // 图标样式class
  //   iconUrl: dingyue,
  //   children: [
  //     {
  //       path: '/agent/agentMeg',
  //       component: () => import('@/views/agent/agentMeg/agentMeg.vue'),
  //       name: '代理商销售管理',
  //       menuShow: true,
  //     },
  //   ],
  // },
  {
    path: '/',
    component: LayoutSidebar,
    leaf: false, // 只有一个节点
    menuShow: false,
    idthat: '004',
    meta: {
      idthat: '004',
    },
    iconCls: 'menu-icon', // 图标样式class
    iconUrl: xitong,
    name: '账号管理',
    children: [
      {
        path: '/agent/agentMeg',
        component: () => import('@/views/agent/accountManage/index.vue'),
        name: '用户列表',
        menuShow: true,
        meta: {
          idthat: '004',
        },
      },
      {
        path: '/agent/role',
        component: () => import('@/views/agent/roleManage/index.vue'),
        name: '角色管理',
        menuShow: true,
        meta: {
          idthat: '004',
        },
      },
      {
        path: '/agent/permissions',
        component: () => import('@/views/agent/permissionsManage/index.vue'),
        name: '权限分配',
        menuShow: true,
        meta: {
          idthat: '004',
        },
      },
    ],
  },
  ...followUpRouter,
  ...electronicContractRouter,
  errorRouter,
  { path: '*', redirect: '/error/404' },
]

// 初始化方法
const createRouter = () =>
  new Router({
    // mode: 'history', // 需要服务端支持
    scrollBehavior: () => ({ y: 0 }),
    routes: defaultRouter,
  })

const router = createRouter()
// 重复点击导航时，控制台出现报错 ，虽然不影响功能使用，但也不能坐视不管。
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}

// 重置路由,参考链接 https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
